module.exports = __webpack_public_path__ + "img/bank_machine.f8c714de.jpg";